module.exports = ".content {\n  width: 90%;\n  margin-left: 5%;\n  margin-right: 5%; }\n\n.btn-info:focus,\n.btn-info:active,\n.btn-info.active {\n  color: #333;\n  background-color: #ccc;\n  border-color: #fff; }\n\n.btn-link {\n  color: #428bca;\n  text-decoration: none; }\n\n.inactive {\n  color: grey; }\n\n.btn-link.inactive:hover,\n.btn-link.inactive:focus {\n  color: #428bca; }\n\n.switch-buttons {\n  margin-top: 10px;\n  margin-bottom: 15px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/admin/locations/admin-locations-overview.component.scss
// module id = ./src/app/admin/locations/admin-locations-overview.component.scss
// module chunks = main